import { render, staticRenderFns } from "./ds-status-tag.vue?vue&type=template&id=4d196eac&scoped=true"
import script from "./ds-status-tag.vue?vue&type=script&lang=js"
export * from "./ds-status-tag.vue?vue&type=script&lang=js"
import style0 from "./ds-status-tag.vue?vue&type=style&index=0&id=4d196eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d196eac",
  null
  
)

export default component.exports